module.exports = {
    array: require('./array'),
    filesystem: require('./filesystem'),
    function: require('./function'),
    object: require('./object'),
    string: require('./string')
};
